import api from "../api";

const setJWTToken = token => {
  // api.defaults.baseURL = "http://167.86.86.168:8081"
  if (token) {
    api.defaults.headers.common["Authorization"] = token;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};

export default setJWTToken;
